<div *ngIf="entities" class="grid">

	<ng-container *ngFor="let entity of entities">
		<!-- Card Template Provided-->
		<ng-container  *ngIf="cardTemplate">
			<ng-container [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{ $implicit: entity }"></ng-container>
		</ng-container>

		<mat-card *ngIf="!cardTemplate" class="col col-3">
			<!-- Default Card -->
			<div class="p-4">
				<mat-card-title>{{ entity.name }}</mat-card-title>
				<mat-card-content>
					<p class="font-size-small">
					Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
					labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
					aliquip ex ea commodo consequat.
					</p>
				</mat-card-content>
			</div>

		</mat-card>
	</ng-container>
</div>

<div *ngIf="paginationMode === 'more' && (page * limit) < totalResults" class="more-container">
	<button mat-button class="more-button" color="primary" (click)="updatePagination.emit({ pageIndex: page, previousPageIndex: page, pageSize: limit, length: totalResults, append: true })" i18n="Load More Button@@gridCollectionLoadMoreButton">Load More</button>
</div>

<mat-paginator
	class="grid-paginator"
	*ngIf="paginationMode === 'paginator'"
	[pageIndex]="page - 1"
	[pageSize]="limit"
	[length]="totalResults"
	[pageSizeOptions]="limitOptions"
	(page)="updatePagination.emit($event)"
></mat-paginator>

